import { render, staticRenderFns } from "./DirectoryList.vue?vue&type=template&id=fdfa2154"
import script from "./DirectoryList.vue?vue&type=script&lang=js"
export * from "./DirectoryList.vue?vue&type=script&lang=js"
import style0 from "./DirectoryList.vue?vue&type=style&index=0&id=fdfa2154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports